import { Link } from "react-router-dom";

/**
 * 커리큘럼 페이지 공용 버튼.
 * 데이터에 `to`가 있으면 앱 내부 라우팅(Link), `href`가 있으면 외부 링크(새 탭)로 렌더한다.
 *
 * @param {{label:string, to?:string, href?:string, tone?:string}} action
 * @param {string} [className] 버튼 톤 외에 추가로 붙일 클래스
 */
export default function CurriculumCta({ action, className = "" }) {
    if (!action) return null;

    const tone = action.tone ? ` curriculum-btn--${action.tone}` : "";
    const classes = `curriculum-btn${tone}${className ? ` ${className}` : ""}`;

    if (action.href) {
        return (
            <a
                className={classes}
                href={action.href}
                target="_blank"
                rel="noopener noreferrer"
            >
                {action.label}
            </a>
        );
    }

    return (
        <Link className={classes} to={action.to}>
            {action.label}
        </Link>
    );
}
